import React from "react";

import { Button, ButtonGroup, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { FootfallMeasureType } from "modules/customer/tools/product/productStoreFit/footfallMeasureType";
import {
    selectAverageDailyFootfallMeasure,
    setAverageDailyFootfallMeasure
} from "modules/customer/tools/product/productStoreFit/productStoreFitSlice";
import { useAppDispatch, useAppSelector } from "store";

const StyledButtonGroup = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark,
        marginBottom: theme.spacing(2),
        borderRadius: "6px"
    },
}))(ButtonGroup);

const StyledButton = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: (props: any) => props["data-is-selected"] ? theme.palette.quaternary.light : theme.palette.quaternary.dark,
        color: theme.palette.common.white,
        borderRadius: "6px",
        "&:hover": {
            // @ts-ignore
            backgroundColor: (props: any) => props["data-is-selected"] ? theme.palette.quaternary.light : theme.palette.quaternary.dark,
            color: theme.palette.common.white,
        },
        "&.MuiButtonGroup-groupedHorizontal:not(:firs-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedHorizontal:not(:last-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedContainedHorizontal:not(:first-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child)": {
            border: 0,
            borderRadius: "6px"
        }
    }
}))(Button);

const AverageDailyFootfallMeasure: React.FC = () => {
    const dispatch = useAppDispatch();
    const footfallMeasure = useAppSelector(selectAverageDailyFootfallMeasure);

    const handleVisitsClick = () => {
        dispatch(setAverageDailyFootfallMeasure(FootfallMeasureType.NumberOfVisits));
    };

    const handleDwellTimeClick = () => {
        dispatch(setAverageDailyFootfallMeasure(FootfallMeasureType.DwellTime));
    };

    return (
        <StyledButtonGroup
            variant="contained"
            size="medium"
            color="default"
            disableElevation
        >
            <StyledButton
                data-is-selected={footfallMeasure === FootfallMeasureType.NumberOfVisits}
                onClick={handleVisitsClick}
            >
                <Typography variant="subtitle2" component="div">
                    Visits
                </Typography>
            </StyledButton>
            <StyledButton
                data-is-selected={footfallMeasure === FootfallMeasureType.DwellTime}
                onClick={handleDwellTimeClick}
            >
                <Typography variant="subtitle2" component="div">
                    Dwell time
                </Typography>
            </StyledButton>
        </StyledButtonGroup>
    );
};

export default AverageDailyFootfallMeasure;
